import { z } from "zod";

/** Magic-link sign-in: the email is the only credential the user types. */
const emailField = () => z.string().trim().min(1, { message: 'Email is required' }).email({ message: 'Invalid email' })

export const authSchema = z.object({
    email: emailField(),
});

/** Strapi users-permissions `/auth/local` (email + password). */
export const localSignInSchema = z.object({
    email: emailField(),
    password: z.string().min(1, { message: 'Password is required' }),
});

export type LocalSignInSchema = z.infer<typeof localSignInSchema>;

export const registerSchema = z.object({
    email: z.string().email(),
    password: z.string().min(8),
    confirmPassword: z.string().min(8),
    username: z.string().min(3),
}).refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
});
export type AuthSchema = z.infer<typeof authSchema>;
export type RegisterSchema = z.infer<typeof registerSchema>;